var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDashboard(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.2122 31.695V27.6061C16.2122 26.566 17.0601 25.7209 18.1106 25.714H21.9587C23.0143 25.714 23.8699 26.5611 23.8699 27.6061V27.6061V31.7077C23.8697 32.5908 24.5816 33.3125 25.4733 33.3332H28.0387C30.5961 33.3332 32.6693 31.2807 32.6693 28.7489V28.7489V17.117C32.6556 16.1209 32.1832 15.1856 31.3866 14.5772L22.6129 7.58024C21.0759 6.36193 18.8909 6.36193 17.3538 7.58024L8.61864 14.5899C7.81895 15.1959 7.34579 16.1327 7.33594 17.1296V28.7489C7.33594 31.2807 9.4091 33.3332 11.9665 33.3332H14.5319C15.4457 33.3332 16.1866 32.5998 16.1866 31.695V31.695",
    stroke: "#086880",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/Dashboard.5a17a6b66f5d6e59bc014c768febe64e.svg";
export { ForwardRef as ReactComponent };